module.exports = __webpack_public_path__ + "static/media/ResponPic3.b0597816.jpg";